import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import config from 'src/app/config';
import { Locale } from '../../enum/locale.enum';
import { PersonalUserData, UserMinimalData } from '../personal-user-data/personal-user-data';
import { Gender } from '../../enum/gender.enum';
import { ProgressBarColor, ScoreLevels } from './utils-data';

@Injectable({
  providedIn: 'root'
})

export class UtilsService {

  constructor(public translate: TranslateService) { }
  public arrayBufferToBase64(buffer: any) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  public getNow() {
    let hour: number = new Date().getHours();
    let minutes: number = new Date().getMinutes();
    let timestamp: string = `${hour}:${minutes<10?'0':'' + minutes}`;
    return timestamp;
  }

  public getInitialis(first:string| undefined, last:string | undefined): string {
    return ((first ? first.charAt(0) : '') + (last ? last.charAt(0) : ''));
  }
  
  public dateToTimeAgo(date : Date): string {
    let than = new Date(date);
    let now = new Date();
    let seconds = Math.floor((now.getTime() - than.getTime()) / 1000);
  
    let interval = seconds / 31536000;
  
    let translation = "";
    if (interval > 1 && interval < 2) {
      translation =  this.translate.instant("dateToTimeAgo.aYearAgo");;;
      return translation;
    }
    else if (interval > 1) {
      translation = this.translate.instant("dateToTimeAgo.yearsAgo", { value: Math.floor(interval) });
      return translation;
    }

    interval = seconds / 2592000;
    if (interval > 1 && interval < 2) {
      translation =  this.translate.instant("dateToTimeAgo.aMonthAgo");;;
      return translation;
    }
    else if (interval > 1) {
      translation = this.translate.instant("dateToTimeAgo.monthsAgo", { value: Math.floor(interval) });
      return translation;
    }

    interval = seconds / 604800;
    if (interval > 1 && interval < 2) {
      translation =  this.translate.instant("dateToTimeAgo.aWeekAgo");;;
      return translation;
    }
    else if (interval > 1) {
      translation = this.translate.instant("dateToTimeAgo.weeksAgo", { value: Math.floor(interval) });
      return translation;
    }

    interval = seconds / 86400;
    if (interval > 1 && interval < 2) {
      translation =  this.translate.instant("dateToTimeAgo.aDayAgo");;;
      return translation;
    }
    if (interval > 1) {
      translation = this.translate.instant("dateToTimeAgo.daysAgo", { value: Math.floor(interval) });
      return translation;
    }

    interval = seconds / 3600;
    if (interval > 1 && interval < 2) {
      translation =  this.translate.instant("dateToTimeAgo.aHourAgo");;;
      return translation;
    }
    if (interval > 1) {
      translation = this.translate.instant("dateToTimeAgo.hoursAgo", { value: Math.floor(interval) });
      return translation;
    }

    interval = seconds / 60;
    if (interval > 1 && interval < 5) {
      translation =  this.translate.instant("dateToTimeAgo.coupleOfMinutesAgo");;;
      return translation;
    }
    if (interval > 1) {
      translation = this.translate.instant("dateToTimeAgo.minutesAgo", { value: Math.floor(interval) });
      return translation;
    }

    translation =  this.translate.instant("dateToTimeAgo.justNow");;;
    return translation;
  }

  public delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms*1000) );
  }

  public getBrowserLocale(): Locale {
    const browserLang = navigator.language;
    let locale : Locale;
    // navigator.language return the partial lang of en and not en-US
    if (!Locale.en_US.includes(browserLang) && !Locale.he_IL.includes(browserLang)){
     locale = config.defaultLocale;
    }
    else{
     if (Locale.en_US.includes(browserLang)){
       locale = Locale.en_US;
     }
     else {
       locale = Locale.he_IL;
     }
    }

    return locale;
  }

  daysBetween(startDate : Date, endDate: Date) : number {
    var millisecondsPerDay = 24 * 60 * 60 * 1000;
    return (endDate.getTime() - startDate.getTime()) / millisecondsPerDay;
}

public getScoreFromGapArray(userData: PersonalUserData | UserMinimalData): number{

  let totalFactors = 0;

  for (let currMotivation of userData.motivations){
    totalFactors += userData.motivationsGap[currMotivation];
  }
  
  // round up to the next integer
  const score = Math.ceil( totalFactors / (userData.motivations.length * config.maxGapFactor)  * 100);

  return (score);
}
  public buildVideoNameByGenderAndLocale(prefix:string, suffix: string, userDetails: PersonalUserData): string{
    let retVal = "";
    let conditionalData = "";

    if (userDetails.locale == Locale.en_US){
      // eng non gender
      conditionalData = 'eng.ng';
    }
    else if (userDetails.locale == Locale.he_IL){
      // locale is Heb - check for gender
      if (userDetails.gender == Gender.FEMALE){
        conditionalData = 'heb.f';
      }
      else if (userDetails.gender == Gender.MALE){
        conditionalData = 'heb.m';
      }
    }

    retVal = prefix + '.' + conditionalData + suffix;
 
    return retVal;
  }

  public calculateProgressBarColor(score: number): string {
    if (!score) return '';
    if (score <= ScoreLevels.LOW) return ProgressBarColor.LOW;
    if (score <= ScoreLevels.MEDIUM) return ProgressBarColor.MEDIUM;
    if (score > ScoreLevels.MEDIUM) return ProgressBarColor.HIGH; 
    return '';
  }

  public convertKeysToInt(obj: { [key: string]: number }): { [key: number]: number } {
    const result: { [key: number]: number } = {};
    Object.keys(obj).forEach(key => {
      result[Number(key)] = obj[key];
    });
    return result;
  }

  public moveToStartOfList<T extends {id: string}>(
    list: T[],
    idToFront: string
  ): T[] {
    const target = list.find(item => item.id === idToFront);
    if (!target) return list;  // nothing to do
    // build a new array: [target, ...everything else]
    return [target, ...list.filter(item => item.id !== idToFront)];
  }

 public chat_extractUUID(fullString: string): string | undefined {
    const uuidRegex = /#*#*#*<([0-9a-fA-F-]{36})>/;
    const match = fullString.match(uuidRegex);
    return match ? match[1] : undefined;
  }

 public chat_formatRawMessage(unformattedMessage: string): string {
    let formattedText = unformattedMessage.replace(
      /\*\*(.*?)\*\*/g,
      '<strong>$1</strong>'
    );
    formattedText = formattedText.replace(/### (.+)/g, '<h2>$1</h2>');

    // Convert markdown links [text](url) to clickable <a> tags
    formattedText = formattedText.replace(
      /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    );

    // Convert remaining raw URLs (not already inside an href) to clickable links
    formattedText = formattedText.replace(
      /(?<!href=")(https?:\/\/[^\s<)]+)/g,
      '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
    );

    return formattedText;
  }

  public removeStructuredProcessMarkupsFromText(text: string): string {
    const cleanedText = text.replace(/~\$.*?\$~/g, '');

    return cleanedText;
  }
}

  
